<template>
    <div class="mt-2 mb-2">
        <div @click="onButtonClick">
            <div class="d-none d-md-block">
                <div class="d-flex justify-content-center">
                    <div class="banner">
                        <img :src="imagePath" alt="ぼちぼちでんなー" />
                    </div>
                </div>
            </div>
            <div class="d-md-none d-flex justify-content-center">
                <div class="d-flex justify-content-center">
                    <div class="bannermd">
                        <img :src="imagePathMd" alt="ぼちぼちでんなー" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Global from '@/mixins/global'
import AudioSourcePlayable from '@/mixins/AudioSourcePlayable'
import store from '../store/store'

export default {
    name: 'AudioBanner',
    mixins: [Global, AudioSourcePlayable],
    props: {
        audioItem: {
            type: Object,
        },
    },
    computed: {
        imagePath: function () {
            const imagePath = this.generateDataPath('./banner.jpg')
            return imagePath
        },
        imagePathMd: function () {
            const imagePath = this.generateDataPath('./banner_md.jpg')
            return imagePath
        },
    },
    methods: {
        onButtonClick: function () {
            if (store.getSelectMode()) {
                this.playSelected(this.audioItem)
                store.editControl.addEditControl(this.audioItem)
            } else {
                this.play(this.audioItem)
            }
        },
    },
}
</script>

<style scoped>
.banner {
    margin: 2px;
    padding: 1px;
    border-radius: 10px;
    width: 70%;
    border: solid;
    border-width: 1px;
    background: linear-gradient(to right, #be93c1, #be93c1);
}
.bannermd {
    margin: 2px;
    padding: 1px;
    border-radius: 10px;
    width: 100%;
    border: solid;
    border-width: 1px;
    background: linear-gradient(to right, #be93c1, #be93c1);
}
img {
    height: auto;
    width: 100%;
    margin: 0px;
    padding: 0px;
    border-radius: 10px;
}
</style>
